import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../hooks/context";
import useTestPayment from "../../hooks/useTestPayment";
import useTimeCount from "../../hooks/useTimeCount";
import PaymentClose from "../../components/button/PaymentClose";
import CustomModal from "../../components/modal/CustomModal";

import "./QuickPay.css";

const QuickPay = () => {
  const count = useTimeCount();
  const [open, setOpen] = useState(false);
  const { addSelectedItem } = useGlobalContext();
  const { message, onPayment, onClose } = useTestPayment();

  useEffect(() => {
    if (count === 120) {
      onClose();
      setOpen(false);
    }
  }, [count, onClose]);

  useEffect(() => {
    if (
      message.toLowerCase() === "success" ||
      message.toLowerCase() === "approved" ||
      message.toLowerCase() === "cancelled"
    ) {
      setOpen(false);
    }
  }, [message]);

  const closeHandler = () => {
    onClose();
    setOpen(false);
  };

  const handleAmount = (value) => {
    setOpen(true);
    const payload = { id: "-1", name: "Touch Tap Go", price: String(value) };
    addSelectedItem(payload);
    onPayment(value);
  };

  let content = "";
  switch (message.toLowerCase()) {
    case "please follow the instructions on the terminal.":
      content = (
        <p className="text-3xl font-semibold tracking-wider">{message}</p>
      );
      break;

    case "terminal busy":
      content = (
        <>
          <p className="text-3xl font-semibold tracking-wider">{message}</p>
          <PaymentClose onClose={closeHandler} />
        </>
      );
      break;

    default:
      content = (
        <>
          <p className="text-3xl font-semibold tracking-wider">{message}</p>
          <PaymentClose onClose={closeHandler} />
        </>
      );
  }

  return (
    <div className="">
      <div className="absolute bottom-[20%] -right-[18.5%] z-10">
        <div className="spin spin-btn my-auto flex justify-center items-center z-20">
          <h3 className="items-center">
            <span className="items-center">Touch</span> <span>Tap</span>{" "}
            <span>Go</span>
          </h3>
        </div>

        <div className="quickPay border-gray-100 border-[12px] klg:border-[25px] w-[400px] h-[400px] klg:w-[800px] klg:h-[800px]">
          <button className="five wheel-btn" onClick={() => handleAmount(5)}>
            <span className="wheel-btn-text"> $5</span>
          </button>
          <button className="six wheel-btn" onClick={() => handleAmount(10)}>
            <span className="wheel-btn-text"> $10</span>
          </button>
          <button className="seven wheel-btn" onClick={() => handleAmount(20)}>
            <span className="wheel-btn-text"> $20</span>
          </button>
          <button className="eight wheel-btn" onClick={() => handleAmount(50)}>
            <span className="wheel-btn-text"> $50</span>
          </button>
        </div>
      </div>
      <CustomModal closeIcon={false} open={open} onClose={closeHandler}>
        <div className="px-5 h-full flex justify-center gap-10 items-center flex-col text-center">
          {content}
        </div>
      </CustomModal>
    </div>
  );
};

export default QuickPay;
